/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { cleanExternalLinks } from '../../lib/utils';

import PrizeCard from '../cards/Prize';

import styles from '../../../styles/lists/awards-list.module.scss';

const propTypes = {
    items: AppPropTypes.listItems,
    isGrid: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    items: null,
    isGrid: false,
    className: null,
};

const AwardsList = ({ items, isGrid, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {(items || []).map((award) => {
            const { title = null, description = null, prizes = null, section = null } = award || {};
            const { label: sectionLabel = null } = section || {};
            return (
                <div className={styles.inner} key={`award-${title}`}>
                    <div className={styles.awardHeader}>
                        {title !== null ? <h2 className={styles.title}>{title}</h2> : null}
                        {title === null && sectionLabel !== null ? (
                            <h2 className={styles.title}>{sectionLabel}</h2>
                        ) : null}
                        {description !== null ? (
                            <div
                                className={styles.description}
                                dangerouslySetInnerHTML={{
                                    __html: cleanExternalLinks(description),
                                }}
                            />
                        ) : null}
                    </div>
                    {(prizes || []).map((prize) => (
                        <PrizeCard
                            item={prize}
                            award={award}
                            vertical={isGrid}
                            className={styles.prize}
                        />
                    ))}
                </div>
            );
        })}
    </div>
);
AwardsList.propTypes = propTypes;
AwardsList.defaultProps = defaultProps;

export default AwardsList;
